<template>
  <div>
    <!-- Skeleton saat loading -->
    <div v-if="isLoading" class="my-3">
      <b-card>
        <div
          v-for="n in 5"
          :key="n"
          class="skeleton-row mb-3 rounded"
        ></div>
      </b-card>
    </div>

    <!-- Jika ada data -->
    <div v-else-if="lengthData > 0">
      <b-table
        striped
        hover
        :items="items"
        :fields="fields"
      ></b-table>

      <!-- Pagination -->
      <b-pagination
        v-if="pagination.last_page > 1"
        class="my-0 my-lg-3"
        v-model="pagination.current_page"
        :total-rows="pagination.total"
        :per-page="pagination.per_page"
        align="center"
        @change="handlePageChange"
      ></b-pagination>
    </div>

    <!-- Jika kosong -->
    <div v-else class="text-center my-4">
      <p class="text-muted">Belum ada pengajuan</p>
    </div>
  </div>
</template>

<script>
import Pengajuan from "../../api/pengajuan.js";

export default {
  name: "Riwayat",
  data() {
    return {
      items: [],
      isLoading: false,
      pagination: {
        current_page: 1,
        last_page: 1,
        total: 0,
        per_page: 10,
      },
      fields: [
        { key: "no", label: "No" },
        { key: "produk", label: "Produk" },
        { key: "mitra", label: "Mitra" },
        { key: "status_pengajuan", label: "Status Pengajuan" },
      ],
      lengthData: 0,
    };
  },

  mounted() {
    this.loadData(this.pagination.current_page);
  },

  computed: {
    currentUser() {
      return this.$store.state.auth.user;
    },
  },

  methods: {
    async handlePageChange(page) {
      this.loadData(page);
    },

    async loadData(page = 1) {
      this.isLoading = true;
      try {
        const res = await Pengajuan.pengajuanFunder({
          page,
          per_page: this.pagination.per_page,
        });

        this.pagination = {
          current_page: res.data.data.current_page,
          last_page: res.data.data.last_page,
          total: res.data.data.total,
          per_page: res.data.data.per_page,
        };

        const resData = res.data.data.data || [];
        this.lengthData = resData.length || 0;
        this.items = resData.map((item, index) => ({
          no: (page - 1) * this.pagination.per_page + (index + 1),
          produk: item.product.nama_produk,
          mitra: item.mitra.mitra_profile.nama_organisasi_perusahaan,
          status_pengajuan: item.status_pengajuan.name,
        }));
      } catch (error) {
        console.error("Error loadData:", error);
        this.items = [];
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>

<style scoped>
.skeleton-row {
  height: 50px; /* lebih tinggi biar mirip row tabel */
  background: linear-gradient(90deg, #f0f0f0 25%, #e6e6e6 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
}

@keyframes shimmer {
  0% {
    background-position: -200% 0;
  }
  100% {
    background-position: 200% 0;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/pengajuan-saya/riwayat.vue